import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
@Injectable({
  providedIn: 'root'
})

 
export class LogserviceService 
{
 
  logMessage(message:any,loglevel:string): Observable<boolean> {
   var result:boolean;
    result = true;
    //console.log(message);
    return of(result);
  }
  constructor() { }
}
